import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import { Locale } from '@doordash/lib-i18n'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import * as FeatureFlags from '../../../experimentConstants'
import i18n from '../../../i18n/'
import { GlobeIcon, LanguageSelect, LanguageSelectWrapper } from './styles'
import supportedLocales from '../../../i18n/supportedLocales'

type ChangeLanguageProps = {
  trackLanguageChanged?: (any) => Promise<any>
}

const onLanguageChange = (newLanguage: Locale, trackLanguageChanged) => {
  trackLanguageChanged(newLanguage)
  return i18n.changeLocale(newLanguage)
}

/**
 * IMPROVE: @peterj35-dd - revisit the use of useState and just compute
 * value and use it directly
 */
export const ChangeLanguage: React.SFC<ChangeLanguageProps> = ({
  trackLanguageChanged,
}) => {
  const [options, setOptions] = React.useState([])

  React.useEffect(() => {
    const locales = { ...supportedLocales }
    if (!isFeatureFlagEnabled(FeatureFlags.DX_WEB_JAPAN_SUPPORT)) {
      delete locales.ja
    }
    if (!isFeatureFlagEnabled(FeatureFlags.DX_ONBOARDING_V2)) {
      delete locales[Locale.EN_NZ]
    }
    const languageOptions = Object.values(locales)
    setOptions(languageOptions)
  }, [])

  return (
    <LanguageSelectWrapper>
      <LanguageSelect
        value={i18n.getCurrentLocale()}
        renderBeforeContent={() => <GlobeIcon />}
        onChange={(newLanguage: Locale) =>
          onLanguageChange(newLanguage, trackLanguageChanged)
        }
        options={options}
      />
    </LanguageSelectWrapper>
  )
}

const mapDispatchToProps = {
  trackLanguageChanged: events.trackLanguageChanged,
}

export default connect(null, mapDispatchToProps)(ChangeLanguage)
